import React, { useState, useEffect, useRef } from 'react';
import PdsIcon from '../../images/pds-icon.svg';
import EmailVerificationImage from '../../images/email-verification.png';
import { EmailVerification } from './styles.js';
import { sendVerificationEmail } from 'supertokens-web-js/recipe/emailverification';
import { Icon, message } from 'antd';
import { withTranslation } from 'react-i18next';
import { EMAIL_VERIFICATION_PAGE } from './translationValues';
import LogOutModal from '../../components/Modals/LogOutModal';
import { LOGOUT_MODAL } from '../../components/Modals/translationValues';

const NAMESPACES = ['EMAIL_VERIFICATION_PAGE', 'LOGOUT_MODAL'];

// TODO:
// 1. When user verifies email from a different device, ask user to login

//This page will be rendered after
// 1. the user signs up
// 2. the password reset email has been sent
function EmailVerificationPage(props) {
  const [isBtnDisabled, setIsBtnDisabled] = useState(() => ( false)); //Disable resend button initially on page load
  const [isLogoutBtnDisabled, setIsLogoutBtnDisabled] = useState(() => false);
  const [timerStart, setTimerStart] = useState(30);
  const [emailSent, setEmailSent] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ModalVisibility, setModalVisibility] = useState(false);
  const { t } = props;
 
  //Resend email to user's inbox
  const resendEmail = async e => {
    try {
        if(isBtnDisabled) return;
        setIsBtnDisabled(true);
        setIsLoading(true);
        let response = await sendVerificationEmail();
        setIsLoading(false);

        if (response.status === 'EMAIL_ALREADY_VERIFIED_ERROR') {
          // This can happen if the info about email verification in the session was outdated.
          setError(t(EMAIL_VERIFICATION_PAGE.EMAIL_VERIFIED_ERROR_MESSAGE.key, EMAIL_VERIFICATION_PAGE.EMAIL_VERIFIED_ERROR_MESSAGE.value));
          // window.location.assign("/home");
        } else {
          // email was sent successfully.
          setEmailSent(true);
          message.success(t(EMAIL_VERIFICATION_PAGE.EMAIL_SENT_SUCCESS_MESSAGE.key, EMAIL_VERIFICATION_PAGE.EMAIL_SENT_SUCCESS_MESSAGE.value));
        }
      } catch (err) {
        if (err.isSuperTokensGeneralError === true) {
          // this may be a custom error message sent from the API by you.
          message.error(err.message);
        } else {
          message.error(EMAIL_VERIFICATION_PAGE.SOMETHING_WENT_WRONG_ERROR_MESSAGE.key, EMAIL_VERIFICATION_PAGE.SOMETHING_WENT_WRONG_ERROR_MESSAGE.value);
        }
      }
      if (e !== undefined) {
        setTimerStart(30);
        startTimer();
      } else {
        setTimerStart(30);
      }    
  };

  //Start timer for resending email
  const startTimer = () => {
    let timer = setInterval(() => {
      setTimerStart(prev => {
        if (prev == 0) {
          clearInterval(timer);
          setIsBtnDisabled(prev => !prev);
        } else {
          if (prev - 1 < 10) {
            sessionStorage.setItem('timerCount', '0' + (prev - 1));
            return '0' + (prev - 1);
          } else {
            sessionStorage.setItem('timerCount', prev - 1);
            return prev - 1;
          }
        }
      });
    }, 1000);
  };

  // Preventing resend email timer to reset on page refresh
  useEffect(() => {
      if(sessionStorage.getItem('timerCount') && sessionStorage.getItem('timerCount') != '00') {
        setTimerStart(sessionStorage.getItem('timerCount'));
        setIsBtnDisabled(true);
        startTimer();
      }
  }, []);

  //Logout user
  const logOutUser = () => {
    setModalVisibility(true);
  };

  return (
  error != null
    ?
    <EmailVerification>
      <div className='error-container'>
        <img className="pds-logo" src={PdsIcon} alt="Perfect Doc Studio"/>
        <h2 className="heading">{t(EMAIL_VERIFICATION_PAGE.EMAIL_VERIFICATION_FAILED_TITLE.key, EMAIL_VERIFICATION_PAGE.EMAIL_VERIFICATION_FAILED_TITLE.value)}</h2>
        <h4 className="error-message">{error}</h4>
      </div>
    </EmailVerification>
    :
    emailSent
      ?
      <>      
        <EmailVerification>
          <div className={`container full-screen }`}>
            <img className="pds-logo" src={PdsIcon} alt="Perfect DocStudio" />
            <h2 className="heading">{t(EMAIL_VERIFICATION_PAGE.WELCOME_TO_PDS_TITLE.key, EMAIL_VERIFICATION_PAGE.WELCOME_TO_PDS_TITLE.value)}</h2>
            <p className="info">
              {
                t(EMAIL_VERIFICATION_PAGE.EMAIL_SENT_DESCRIPTION.key, EMAIL_VERIFICATION_PAGE.EMAIL_SENT_DESCRIPTION.value)
              }
            </p>
            <img
              className="email-img"
              src={EmailVerificationImage}
              alt={t(EMAIL_VERIFICATION_PAGE.WAITING_FOR_VERIFICATION_ALT_TEXT.key, EMAIL_VERIFICATION_PAGE.WAITING_FOR_VERIFICATION_ALT_TEXT.value)}
            />
            <div className="btn-container">
            <button
              data-hover={t(EMAIL_VERIFICATION_PAGE.RESEND_EMAIL_BUTTON.key, EMAIL_VERIFICATION_PAGE.RESEND_EMAIL_BUTTON.value)}
              className={`btn-resend ${isBtnDisabled ? 'btn-disabled' : ''}`}
              onClick={resendEmail}
            >
              {
                isBtnDisabled 
                  ?
                  isLoading
                    ?
                    <>{t(EMAIL_VERIFICATION_PAGE.SENDING_EMAIL_MESSAGE.key, EMAIL_VERIFICATION_PAGE.SENDING_EMAIL_MESSAGE.value)}<Icon type="loading" /></>
                    :
                    <>
                      {
                        t(EMAIL_VERIFICATION_PAGE.RESEND_IN_BUTTON.key, EMAIL_VERIFICATION_PAGE.RESEND_IN_BUTTON.value) 
                      }
                      00:{timerStart}
                    </>
                  : 
                  <div>{t(EMAIL_VERIFICATION_PAGE.RESEND_EMAIL_BUTTON.key, EMAIL_VERIFICATION_PAGE.RESEND_EMAIL_BUTTON.value)}</div>
              }
            </button>
            <button
            data-hover={t(`LOGOUT_MODAL:${LOGOUT_MODAL.LOGOUT_BUTTON.key}`, LOGOUT_MODAL.LOGOUT_BUTTON.value)}
            className={`btn-logout ${isLogoutBtnDisabled ? 'logout-btn-disbled' : ''}`}
            onClick={logOutUser}
            >
              <div>{t(`LOGOUT_MODAL:${LOGOUT_MODAL.LOGOUT_BUTTON.key}`, LOGOUT_MODAL.LOGOUT_BUTTON.value)}</div>
            </button>  
            </div>
          </div>
        </EmailVerification>
        <LogOutModal visible={ModalVisibility} OnCancel={() => setModalVisibility(false)} />
      </>
      : 
      null
  )  
}

export default withTranslation(NAMESPACES)(React.memo(EmailVerificationPage));
